import React, { FC, HTMLProps, MouseEvent, ReactNode, forwardRef } from 'react';
import classNames from 'classnames';
import styles from './nav_item.module.scss';
import { Hyperlink } from '../../../components/Hyperlink';
import { CustomDropdown } from '../../../components/custom-dropdown/CustomDropdown';

export const NavItem: FC<{ className?: string }> = ({
  children,
  className,
}) => {
  return (
    <span className={classNames(styles.container, className)}>{children}</span>
  );
};

export const NavItemLink: FC<HTMLProps<HTMLAnchorElement> & {
  source?: string;
}> = ({ children, ...props }) => {
  const { className, ...propsWithoutClassname } = props;

  return (
    <Hyperlink
      {...propsWithoutClassname}
      className={classNames(styles.container, className)}
    >
      {children}
    </Hyperlink>
  );
};

export function NavItemDropdown({
  className,
  children,
}: {
  className?: string;
  children: (isOpen: boolean, toggle: Function) => ReactNode;
}) {
  return (
    <CustomDropdown className={classNames(styles.container, className)}>
      {(isOpen, toggle) => children(isOpen, toggle)}
    </CustomDropdown>
  );
}

type Props = {
  className?: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
  dataSource?: string;
  id?: string;
  children: ReactNode;
};

export const NavItemButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, className, dataTestId, dataSource, id, children }, ref) => (
    <button
      type="button"
      onClick={onClick}
      data-source={dataSource}
      data-test-id={dataTestId}
      className={classNames(styles.container, className)}
      id={id}
      ref={ref}
    >
      {children}
    </button>
  ),
);
